import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSearchResult} from 'src/openapi/admin/models/AccountSearchResult';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultSlice = getCachedTableDataSlice<
    AccountSearchResult[],
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResult');

export const accountSearchResultActions = accountSearchResultSlice.actions;
const accountSearchResultCacheSelector: CachedTableCacheSelector<AccountSearchResult[]>
    = state => state.accountSearchResult.result.cache;
export const accountSearchResultDataSelector: CachedTableDataSelector<AccountSearchResult[]>
    = state => state.accountSearchResult.result;
export const accountSearchResultResultSelector = getCachedTableResultSelector(
    accountSearchResultCacheSelector,
    accountSearchResultStateSelector,
);
